export function initializeYBug() {
    window.ybug_settings = {'id': 'p16vwycg8msxwwr9dsr5', hide_launcher: true};
    var ybug = document.createElement('script');
    ybug.type = 'text/javascript';
    ybug.async = true;
    ybug.src = 'https://widget.ybug.io/button/' + window.ybug_settings.id + '.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ybug, s);
}
